<!-- 单页以及普通新闻详情模板 -->
<template>
  <div>
    <div class="biaoqian">
      您当前的位置：
      <a :href="baseUrl + '/'">首页</a> >>
      <span v-if="dh.parent != null">
        <a
          :href="baseUrl + (dh.parent.classTemplet+'?classId='+dh.parent.classId)"
        >{{dh.parent.classCName}}</a> >>
      </span>
      <span v-if="dh.child != null">
        <a
          :href="baseUrl + (dh.child.classTemplet+'?classId='+dh.child.classId)"
        >{{dh.child.classCName}}</a> >>
      </span>
      <span v-show="flag == 1">
        <a>正文</a>
      </span>
    </div>
    <div class="zy-dh">
      <div>
        <!--侧导航-->
        <h3 class="zy-dh1">
          <a href="#" accesskey="x" :title="parent">{{parent}}</a>
        </h3>
        <ul class="zy-list">
          <li v-for="(item,index) in child" :key="index">
            <a
              :href="item.isUrl == 1?item.urlAddress:baseUrl + (item.classTemplet+'?classId='+item.classId)"
              class
            >{{item.classCName}}</a>
          </li>
        </ul>
      </div>
      <!-- 通知公告 -->
      <tzgg></tzgg>
      <!-- 辅助器具 -->
      <zcfg></zcfg>
    </div>
    <div>
      <div class="zy-nr1">
        <span>{{classCName}}</span>
      </div>
      <div class="zy-nr2">
        <div class="box-100">
          <!-- 新闻发布人以及发布时间 -->
          <div v-show="flag == 1">
            <h4>{{newsTitle}}</h4>
            <div class="hui99 border-1">/ 发布人：{{createBy}} / 发布时间：{{editorTime}} /</div>
            <p></p>
          </div>
          <!-- 单页以及详情页 -->
          <div v-show="isPage == 1 || flag == 1" id="container" v-html="pageContent"></div>
          <!-- 附件下载 -->
          <div v-show="isFiles == 1" style="margin-top:20px;">
            <div v-for="(item,index) in files" :key="index">
              附件下载：
              <span @click="download(item)">
                <a :title="'附件下载：'+item.realName">{{item.realName}}</a>
                <br>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newsClass from "../../http/web/newsClass";
import news from "../../http/web/news";
import merge from "webpack-merge";
import { home } from "../../http/home";
import tzgg from "../clgk/components/tzgg";
import zcfg from "../clgk/components/zcfg";
import localStorage from "../../http/web/localStorage";
import { mapState } from "vuex";
import {transferTime} from '../../http/web/dateFormat'
export default {
  data() {
    return {
      parent: "",
      child: [],
      classCName: "", //栏目名称
      classId: "",
      pageContent: "", //单页内容
      flag: 0, //是否展示详情，1：展示详情，0：不展示
      newsId: "",
      createBy: "",
      editorTime: "",
      newsTitle: "",
      isFiles: 0, //是否包含附件，0：不包含，1：包含
      files: [],
      dh: ""
    };
  },
  components: {
    tzgg,
    zcfg
  },
  computed: {
    ...mapState({
      baseUrl: state => state.global.baseUrl
    })
  },
  mounted: function() {
    //获取路由中的参数，newsId说明是跳转的新闻详情，classId说明跳转的是栏目单页
    this.newsId = this.$route.query.newsId;
    this.classId = this.$route.query.classId;
    if (this.classId != undefined) {
      this.flag = 0;
      //根据classId作为parentId查找他的子栏目以及相关信息
      newsClass.queryParent(this.classId).then(item => {
        this.parent = item.classCName; //classCName是栏目中文名
        if (item.child != null && item.content != "") {
          //如果存在子栏目
          Array.from(item.child).forEach(c => {
            //child是用来展示侧边导航的
            this.child.push(c);
            if (c.classId == this.classId) {
              //如果点击的是导航栏中的子栏目则跳转
              this.setNewsClass(c);
            }
          });
        } else {
          this.setNewsClass(item);
          this.editorTime = transferTime(item.editorTime)
        }
      });
      //标签回退功能，获得当前栏目以及父栏目
      newsClass.daoHang(this.classId).then(i => {
        this.dh = i;
      });
    }
    if (this.newsId != undefined) {
      //展示新闻详情
      //根据newsId获得新闻对象
      news.queryByNewsId(this.newsId).then(item => {
        this.classId = item.classId;
        //侧标导航设置相关信息
        newsClass.queryParent(this.classId).then(res => {
          this.parent = res.classCName;
          if (res.child != null) {
            Array.from(res.child).forEach(c => {
              this.child.push(c);
              if (c.classId == this.classId) {
                this.classCName = c.classCName;
              }
            });
          } else {
            this.classCName = res.classCName;
          }
        });
        this.pageContent = item.content;
        this.createBy = item.createBy;
        // console.log("item.editorTime", item.editorTime);
        this.editorTime = transferTime(item.editorTime)
        this.newsTitle = item.newsTitle;
        //设置显示新闻详情，默认是显示单页
        this.flag = 1;
        //判断是否包含附件
        if (item.isFiles == 1) {
          this.isFiles = item.isFiles;
          //根据新闻id查找相关附件
          localStorage.findByNewsId(item.newsId).then(res => {
            res.forEach(i => {
              var file = {
                realName: '',
                storageId: '',
              };
              //获取文件类型
              var indexType = parseInt(i.realName.lastIndexOf('.'));
              var typeName = i.realName.substring(indexType,i.realName.length);
              //处理文件名称，去掉文件后边的数字
              //先判断是否包含指定字符'-'
              var lastFileName = i.realName;
              var indexZF = parseInt(i.realName.lastIndexOf('-'));
              if(indexZF > 0){
                //去除文件名称中最后一个'-'及后边的数字；暂时存在文件名中存在'-'，截取后名称会不完整
                lastFileName = lastFileName.substring(0,indexZF)+typeName;
              }
              
              file.realName = lastFileName;
              file.storageId = i.id;
              this.files.push(file)
            });
          });
        }
        //标签回退功能，获得当前栏目以及父栏目
        newsClass.daoHang(this.classId).then(i => {
          this.dh = i;
        });
      });
    }
  },
  methods: {
    //附件下载
    download(item) {
      localStorage.download(item.storageId).then(data => {
        localStorage.downloadFileT(data, item.realName);
      });
    },
    //设置变量信息
    setNewsClass(item) {
      this.classCName = item.classCName;
      this.classId = item.classId;
      this.isPage = item.isPage;
      this.pageContent = item.pageContent;
      this.createBy = item.createBy;
      this.newsTitle = item.newsTitle;
    }
  }
};
</script> 


// WEBPACK FOOTER //
// src/views/page/index.vue